import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconGooglePlayBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGooglePlayBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b9e154b2bfa08b48bcb020035b53132ac375a7a7', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '92784f45421fb2a88839f51ba7f865daa507bd87', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ead1c62bf80d3a88e331432c9f02fc5e843901a5', d: "M14.139 13.372a411 411 0 0 1 3.057-1.824c.35-.202.71-.739 0-1.156-.23-.131-1.463-.87-3.057-1.824l-2.195 2.408z", fill: "#FBBC04" }), h("path", { key: '97a847fb9d7ad7787eae16858e7a81d8604ba3e7', d: "m11.944 10.976-7.009 7.712c.164.024.35-.024.568-.155.458-.274 5.328-3.182 8.636-5.161z", fill: "#EA4335" }), h("path", { key: '576b7eb6d4d2c0b2e69d466c321ed93cf7c4f519', d: "m11.944 10.976 2.195-2.408s-8.145-4.85-8.636-5.137a.8.8 0 0 0-.579-.119z", fill: "#34A853" }), h("path", { key: 'fc59c1830d9b85013b4ddc655b7ea3c68f6ec8d8', d: "m11.944 10.976-7.02-7.664c-.284.072-.524.346-.524.906v13.564c0 .513.186.882.535.918z", fill: "#4285F4" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-google-play-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-google-play-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-google-play-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGooglePlayBranded$1);
            }
            break;
    } });
}

const CosmosIconGooglePlayBranded = CosmosIconGooglePlayBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGooglePlayBranded, defineCustomElement };
